import FullWidthLayout from "@/layouts/FullWidthLayout";
import KRentalPickupsReport from "kinnect-front/KYard/Reports/RentalPickups/Report";
import { Pageable } from "kinnect-mixins";

export default {
	name: "YardRentalPickupsReportPage",

	metaInfo: { title: "Yard - Rental Pickups Report" },

	mixins: [ Pageable ],

	render() {
		return <FullWidthLayout>
			<KRentalPickupsReport></KRentalPickupsReport>
		</FullWidthLayout>;
	}
};
